(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["client-experiences"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ci-client-stories')) {
    customElements.define('ci-client-stories', class extends HTMLElement {
      connectedCallback() {
        this.abort = new AbortController();
        const signal = this.abort.signal;
        let opened = null;
        let opener = null;
        const positionPreview = () => {
          if (!opened || matchMedia('(max-width: 749px)').matches) return;
          const anchor = opener.getBoundingClientRect();
          const box = opened.getBoundingClientRect();
          const below = anchor.bottom + 8;
          const top = below + box.height <= innerHeight - 16 ? below : anchor.top - box.height - 8;
          opened.style.left = `${Math.max(16, Math.min(anchor.left, innerWidth - box.width - 16))}px`;
          opened.style.top = `${Math.max(16, Math.min(top, innerHeight - box.height - 16))}px`;
        };
        this.closeMessage = () => { if (opened && opened.matches(':popover-open')) opened.hidePopover(); opened = null; };
        this.querySelectorAll('[data-message-open]').forEach(button => {
          const preview = document.getElementById(button.dataset.messageOpen);
          button.addEventListener('click', event => {
            if (preview.matches(':popover-open')) { this.closeMessage(); return; }
            this.closeMessage();
            opener = button;
            opened = preview;
            preview.showPopover();
            positionPreview();
            if (event.detail === 0) preview.focus({ preventScroll: true });
          }, { signal });
          preview.addEventListener('toggle', event => {
            button.setAttribute('aria-expanded', String(event.newState === 'open'));
            if (event.newState === 'closed' && opened === preview) opened = null;
          }, { signal });
          let startY = null;
          const handle = preview.querySelector('.ci-clients__preview-header');
          handle.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') { startY = event.clientY; handle.setPointerCapture(event.pointerId); } }, { signal });
          handle.addEventListener('pointerup', event => {
            if (startY !== null && event.clientY - startY > 40) this.closeMessage();
            startY = null;
          }, { signal });
        });
        document.addEventListener('keydown', event => {
          if (event.key === 'Escape' && opened) {
            event.preventDefault();
            this.closeMessage();
            if (opener && opener.isConnected) opener.focus({ preventScroll: true });
          }
        }, { signal });
        window.addEventListener('resize', positionPreview, { passive: true, signal });
        document.addEventListener('scroll', positionPreview, { capture: true, passive: true, signal });
        const track = this.querySelector('.ci-clients__track');
        const buttons = [...this.querySelectorAll('[data-direction]')];
        const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
        const step = () => track.firstElementChild.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
        const move = direction => track.scrollBy({ left: direction * step(), behavior: reduced() ? 'instant' : 'smooth' });
        const update = () => {
          const max = track.scrollWidth - track.clientWidth;
          buttons[0].disabled = track.scrollLeft <= 2;
          buttons[1].disabled = track.scrollLeft >= max - 2;
          this.querySelector('.ci-clients__controls').hidden = max <= 2;
        };
        buttons.forEach(button => button.addEventListener('click', () => move(Number(button.dataset.direction)), { signal }));
        track.addEventListener('scroll', update, { passive: true, signal });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          move(event.key === 'ArrowRight' ? 1 : -1);
        }, { signal });
        let drag = null;
        track.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button, summary, details, [popover]')) return;
          drag = { x: event.clientX, left: track.scrollLeft, moved: false, id: event.pointerId };
        }, { signal });
        track.addEventListener('pointermove', event => {
          if (!drag) return;
          const distance = event.clientX - drag.x;
          if (Math.abs(distance) > 5 && !drag.moved) {
            drag.moved = true;
            track.setPointerCapture(drag.id);
            track.classList.add('is-dragging');
          }
          if (drag.moved) { event.preventDefault(); track.scrollLeft = drag.left - distance; }
        }, { signal });
        const finish = () => {
          if (!drag) return;
          const moved = drag.moved;
          drag = null;
          track.classList.remove('is-dragging');
          if (moved) track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: reduced() ? 'instant' : 'smooth' });
        };
        window.addEventListener('pointerup', finish, { signal });
        track.addEventListener('pointercancel', finish, { signal });
        track.addEventListener('dragstart', event => event.preventDefault(), { signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(track);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('.ci-clients__card');
          if (card) track.scrollTo({ left: card.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft, behavior: 'instant' });
          this.dataset.reveal = 'visible';
        }, { signal });
        if (!this.dataset.reveal && !reduced() && 'IntersectionObserver' in window) {
          this.dataset.reveal = 'pending';
          this.reveal = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.dataset.reveal = 'visible';
              this.reveal.disconnect();
            }
          }, { threshold: .1 });
          this.reveal.observe(this);
        }
        update();
      }
      disconnectedCallback() {
        this.closeMessage();
        this.abort.abort();
        this.resize.disconnect();
        if (this.reveal) this.reveal.disconnect();
        if (this.dataset.reveal === 'pending') delete this.dataset.reveal;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["course-access"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ci-course-access')) {
    customElements.define('ci-course-access', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.reveal || window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.dataset.reveal = 'pending';
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.dataset.reveal = 'visible';
            this.observer.disconnect();
          }
        }, { threshold: .12 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.dataset.reveal === 'pending') delete this.dataset.reveal;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const connectFaq = () => {
      const faq = document.querySelector('.ci-faq');
      if (!faq) return;
      faq.id = 'homepage-faq';
      if (location.hash === '#homepage-faq') faq.scrollIntoView({ block: 'center', behavior: 'instant' });
    };
    connectFaq();
    document.addEventListener('shopify:section:load', connectFaq);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["learning-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ci-learning-journey')) {
    customElements.define('ci-learning-journey', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.reveal || matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
        this.dataset.reveal = 'pending';
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) {
            this.dataset.reveal = 'visible';
            this.observer.disconnect();
          }
        }, { threshold: .1 });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.dataset.reveal === 'pending') delete this.dataset.reveal;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
(() => {
  const positionCartNote = () => {
    const footer = document.querySelector("#main-cart-footer .cart__footer");
    const note = footer?.querySelector("cart-note");
    const blocks = footer?.querySelector(".cart__blocks");
    const anchor = blocks?.querySelector("ci-digital-consent") || blocks?.querySelector(".cart__ctas");
    if (!note || !blocks || !anchor) return;
    if (note.nextElementSibling !== anchor || note.parentElement !== blocks) {
      blocks.insertBefore(note, anchor);
    }
  };
  const initializeCartNote = () => {
    positionCartNote();
    const section = document.getElementById("main-cart-footer")?.parentElement;
    if (section) new MutationObserver(positionCartNote).observe(section, { childList: true, subtree: true });
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeCartNote, { once: true });
  } else {
    initializeCartNote();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
